import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

// Mirrors the subset of next/navigation's useRouter() that the codebase uses:
// router.push(href), router.replace(href), router.back(), router.forward(),
// router.refresh(), router.prefetch().
export function useRouter() {
  const navigate = useNavigate();

  return useMemo(
    () => ({
      push: (href) => navigate(href),
      replace: (href) => navigate(href, { replace: true }),
      back: () => navigate(-1),
      forward: () => navigate(1),
      refresh: () => navigate(0),
      prefetch: () => {},
    }),
    [navigate]
  );
}
